import PropTypes from "prop-types";

export const tabInfoProps = {
  canAddTab: PropTypes.bool,
  title: PropTypes.string,
  dueDate: PropTypes.number,
  description: PropTypes.string,
};
